import { getAuth } from "firebase/auth";
import { initializeApp } from "firebase/app";
import { getStorage } from "firebase/storage";
import { getFirestore } from "firebase/firestore";
import { getMessaging } from "firebase/messaging";
// import { getMessaging}

const firebaseConfig = {
  apiKey: "AIzaSyDoPMGGC5wD1VYUuMco515b2sDqTIRZg78",
  authDomain: "ech-app-70945.firebaseapp.com",
  projectId: "ech-app-70945",
  storageBucket: "ech-app-70945.firebasestorage.app",
  messagingSenderId: "762478781178",
  appId: "1:762478781178:web:195212793b2de961065f43",
  measurementId: "G-7FGRLBGBTN"
};

const app = initializeApp(firebaseConfig);

export const storage = getStorage(app);
export const db = getFirestore(app);
export const auth = getAuth(app);
export const messaging = getMessaging(app);